import React from "react";
import NavBar from "../components/NavBar";

const OrbisLinesTermsPage = ({ language, onLanguageChange, t }) => {
  const thirdPartyProviders = t("orbisTerms.thirdParty.providers") || [];

  return (
    <div className="page foody-page trains-page support-page" id="orbis-terms-top">
      <NavBar
        language={language}
        onLanguageChange={onLanguageChange}
        items={[
          { href: "/apps/orbislines", label: t("orbisTerms.nav.back") },
          {
            href: "/apps/orbislines/static/support",
            label: t("orbisTerms.nav.support"),
          },
        ]}
      />

      <main className="foody-main">
        <section className="foody-hero support-hero">
          <div className="foody-hero-copy">
            <span className="support-pill">{t("orbisTerms.badge")}</span>
            <h1>{t("orbisTerms.hero.title")}</h1>
            <p>{t("orbisTerms.hero.desc")}</p>
            <p className="support-muted">{t("orbisTerms.hero.effectiveDate")}</p>
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-grid support-grid">
            <article className="foody-card">
              <h3>{t("orbisTerms.acceptance.title")}</h3>
              <p>{t("orbisTerms.acceptance.p1")}</p>
              <p>{t("orbisTerms.acceptance.p2")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("orbisTerms.gameplay.title")}</h3>
              <p>{t("orbisTerms.gameplay.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("orbisTerms.intellectualProperty.title")}</h3>
              <p>{t("orbisTerms.intellectualProperty.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("orbisTerms.serviceChanges.title")}</h3>
              <p>{t("orbisTerms.serviceChanges.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("orbisTerms.deviceSecurity.title")}</h3>
              <p>{t("orbisTerms.deviceSecurity.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("orbisTerms.thirdParty.title")}</h3>
              <p>{t("orbisTerms.thirdParty.desc")}</p>
              <ul className="support-list">
                {thirdPartyProviders.map((provider) => (
                  <li key={provider.name}>
                    <a
                      href={provider.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {provider.name}
                    </a>
                  </li>
                ))}
              </ul>
            </article>

            <article className="foody-card">
              <h3>{t("orbisTerms.connectivity.title")}</h3>
              <p>{t("orbisTerms.connectivity.p1")}</p>
              <p>{t("orbisTerms.connectivity.p2")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("orbisTerms.liability.title")}</h3>
              <p>{t("orbisTerms.liability.p1")}</p>
              <p>{t("orbisTerms.liability.p2")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("orbisTerms.updates.title")}</h3>
              <p>{t("orbisTerms.updates.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("orbisTerms.changes.title")}</h3>
              <p>{t("orbisTerms.changes.desc")}</p>
            </article>
          </div>
        </section>

        <section className="foody-cta">
          <div>
            <h2>{t("orbisTerms.contact.title")}</h2>
            <p>
              {t("orbisTerms.contact.desc")}
              <br />
              <a href="mailto:support-orbislines@wodaslabs.com">
                support-orbislines@wodaslabs.com
              </a>
            </p>
          </div>
          <div className="store-badges foody-store-badges">
            <a className="btn primary" href="/apps/orbislines/static/support">
              {t("orbisTerms.contact.cta")}
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default OrbisLinesTermsPage;
